<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root' && rol != 'admin' && rol != 'admin-empresa'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container grid-list-xl fluid v-else>
            <v-row>
                <v-overlay :value="overlay" >
                    <div class="align-center justify-center text-center">
                        <v-progress-circular
                            indeterminate
                            :size="100"
                            :width="7"
                            color="#2DB9D1"
                        >
                            <v-img
                                src="/static/icon/favicon.ico"
                                :width="60"
                            ></v-img>
                        </v-progress-circular>
                        <p class="mt-5">{{fraseOverlay}}</p>
                    </div>
                    
                </v-overlay>
                <v-col lg="12">
                    <data-table
                        ref="tableDocumentos"
                        :tableName="'Tipo de documentos'"
                        :showAdvancedFilters="false"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        :perPage="[10, 25, 50, 100]"
                    >
                        <template slot="actionButtonsLeft">
                            <BtnAcciones :btn-nombre="'Acciones'">
                                <template slot="opciones">
                                    <v-list-item 
                                    dense 
                                    class="btnAccionesItem"
                                    @click="abrirModalReporte">
                                        <v-list-item-title>
                                            <span>Descargar reporte</span>
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>
                            </BtnAcciones>
                            <div class="botonAgregar" style="padding-right: 12px;" v-if="permisos.create">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>

                        </template>
                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td>
                                    <div class="tblPrincipal">
                                        {{ item.nombre_cliente }}
                                    </div>
                                    <div class="tblSecundario">
                                        {{ item.nombre_empresa }}
                                    </div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ item.nombre }}</div>
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    @click="abrirModal('update', item)"
                                                    small
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom v-if="permisos.delete">
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    depressed
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    @click="eliminar(item.id, item.nombre)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon
                                                >
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <template>
            <v-row>
                <v-dialog v-model="dialog" persistent max-width="600px" scrollable>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                    </template>

                    <perfect-scrollbar style="background:#FFF">
                        <v-card elevation="0">
                            <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                    <img :src="imgModal" class="imgModal" />
                                    <h2 class="titleModal">{{ titulo_modal }}</h2>
                                </div>
                            </v-card-title>

                            <v-card-text class="card_texto">
                                <div id="loadingModal" v-show="!finaliza_carga">
                                    <div id="loading">
                                        <v-progress-circular
                                            indeterminate
                                            :size="100"
                                            :width="7"
                                            color="blue"
                                        ></v-progress-circular>
                                    </div>
                                </div>

                                <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                    <v-divider class="divider"></v-divider>
                                    <v-row>
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Nombre"
                                                v-model="documento.nombre"
                                                v-validate="'required'"
                                                data-vv-name="Nombre"
                                                :error-messages="errors.collect('Nombre')"
                                            />
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                            <v-textarea
                                                outlined
                                                label="Descripción"
                                                v-model="documento.descripcion"
                                            ></v-textarea>
                                        </v-col>
                                        <template v-if="rol == 'root'">
                                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                <v-autocomplete
                                                    outlined
                                                    :items="clientes"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    label="Clientes"
                                                    persistent-hint
                                                    v-model="cliente_value"
                                                    v-validate="'required'"
                                                    data-vv-name="Cliente"
                                                    :error-messages="errors.collect('Cliente')"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </template>
                                        <template v-if="rol == 'root' || rol == 'admin'">
                                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                <v-autocomplete
                                                    outlined
                                                    :items="empresas"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    label="Empresas"
                                                    persistent-hint
                                                    v-model="empresa_value"
                                                    v-validate="'required'"
                                                    data-vv-name="Empresa"
                                                    :error-messages="errors.collect('Empresa')"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions v-show="finaliza_carga" class="d-flex justify-end card_accion">
                                <button
                                    class="btnCerrar"
                                    @click="cerrarModal()"
                                    :loading="loading_guardar"
                                >
                                    Cancelar
                                </button>
                                <v-btn
                                    class="btnGuardar"
                                    @click="guardar()"
                                    :loading="loading_guardar"
                                    v-if="(permisos.update) || (permisos.create && permisos.update == false && accion == 'add')"
                                >
                                    Guardar
                                </v-btn> 
                            </v-card-actions>

                            <div class="px-15 pb-10" v-if="permisos.update == false && accion == 'update'">
                                <v-alert
                                    dense
                                    outlined
                                    type="error"
                                    
                                >
                                    El usuario no tiene permiso para editar el registro.
                                </v-alert>
                            </div>
                        </v-card>
                    </perfect-scrollbar>
                </v-dialog>
            </v-row>
        </template>

        <!--dialogo para descarga de reporte-->
        <template>
            <v-dialog  v-model="dialogReporte" persistent max-width="600px" scrollable>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>

                <perfect-scrollbar style="background:#FFF">
                    <v-card elevation="0">
                        <ValidationObserver ref="formReporte" v-slot="{invalid}">
                            <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                    <!-- <img :src="imgModal" class="imgModal" /> -->
                                    <h2 class="titleModal">{{ titulo_modal }}</h2>
                                </div>
                            </v-card-title>
                            <v-card-text class="card_texto">
                                <div id="loadingModal" v-show="!finaliza_carga">
                                    <div id="loading">
                                        <v-progress-circular
                                            indeterminate
                                            :size="100"
                                            :width="7"
                                            color="blue"
                                        ></v-progress-circular>
                                    </div>
                                </div>
                                <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                    <v-divider class="divider"></v-divider>
                                    <v-row>
                                        <template v-if="rol == 'root'">
                                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                <ValidationProvider v-slot="{errors}" name="Cliente" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        :items="clientes"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        label="Clientes"
                                                        persistent-hint
                                                        v-model="cliente_value"
                                                        required
                                                        :error-messages="errors"
                                                        no-data-text="Datos no disponibles"
                                                    >
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>
                                        </template>
                                        <template v-if="rol == 'root' || rol == 'admin'">
                                            <v-col cols="12" xs="12" sm="12" :md="(rol == 'admin') ? '12' : '6'" :lg="(rol == 'admin') ? '12' : '6'" class="py-0">
                                                <ValidationProvider v-slot="{errors}" name="Empresa" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        :items="empresas"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        label="Empresas"
                                                        persistent-hint
                                                        v-model="empresa_value"
                                                        required
                                                        :error-messages="errors"
                                                        no-data-text="Datos no disponibles"
                                                    >
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>
                                        </template>
                                        <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'">
                                            <v-col cols="12" xs="12" sm="12" :md="(rol == 'admin-empresa') ? '12' : '6'" :lg="(rol == 'admin-empresa') ? '12' : '6'" class="py-0">
                                                <v-autocomplete
                                                    outlined
                                                    :items="sucursales"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    label="Sucursal"
                                                    persistent-hint
                                                    v-model="sucursal_value"
                                                    no-data-text="Datos no disponibles"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </template>
                                        <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa' || rol == 'admin-sucursal'">
                                            <v-col cols="12" xs="12" sm="12" :md="(rol == 'admin-sucursal') ? '12' : '6'" :lg="(rol == 'admin-sucursal') ? '12' : '6'" class="py-0">
                                                <v-autocomplete
                                                    outlined
                                                    :items="departamentos"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    label="Departamento"
                                                    persistent-hint
                                                    v-model="depto_value"
                                                    no-data-text="Datos no disponibles"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </template>
                                        <template>
                                            <v-col cols="12" xs="12" sm="12" md="6" lg="6" class="py-0">
                                                <multiple-autocomplete
                                                outlined
                                                :items="empleados"
                                                :valorDefecto="emp_seleccionados"
                                                item_text="nombre"
                                                @dataMultiple="(data) => emp_seleccionados = data"
                                                label="Empleados"
                                                ref="multEmpleado"  
                                                />
                                            </v-col>
                                        </template>
                                        <template>
                                            <v-col cols="12" xs="12" sm="12" md="6" class="py-0">
                                                <v-autocomplete
                                                outlined
                                                :items="tipo_documento"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Documento"
                                                persistent-hint
                                                v-model="documento_value"
                                                no-data-text="Datos no disponibles"
                                                ></v-autocomplete>
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions v-show="finaliza_carga" class="d-flex justify-end card_accion">
                                <button
                                    class="btnCerrar"
                                    @click="cerrarModal()"
                                    :loading="loading_guardar"
                                >
                                    Cancelar
                                </button>
                                <v-btn
                                    class="btnGuardar"
                                    @click="descargarReporte()"
                                    :loading="loading_guardar"
                                    :disabled="invalid"
                                >
                                    Descargar
                                </v-btn> 
                            </v-card-actions>
                        </ValidationObserver>
                        
                    </v-card>
                </perfect-scrollbar>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Notify from "@/plugins/notify";
import PerfectScrollbar from "perfect-scrollbar";

//Apis
import documentoApi from "../api/tipo_documentos";
import clienteAPi from "../api/clientes";
import empresaApi from "../api/empresas";
import sucursalApi from "../api/sucursales";
import departamentoApi from "../api/departamentos";
import empleadoApi from "../api/empleados";

//Componentes
import Datatable from "@/components/datatable/Datatable.vue";
import BtnAcciones from '@/components/BtnAcciones';
import VuetifyMultipleAutocomplete2 from '@/components/VuetifyMultipleAutocomplete2';
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
    components: {
        "data-table": Datatable,
        BtnAcciones,
        "multiple-autocomplete": VuetifyMultipleAutocomplete2,
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            url: "catalogo/tipos-documentos/find",
            columns: [
                {
                    label: "Empresa",
                    name: "empresa",
                    filterable: true,
                },
                {
                    label: "Nombre",
                    name: "nombre",
                    filterable: true,
                },
                {
                    label: "Opciones",
                    name: "opciones",
                    filterable: false,
                    align: 'center'
                },
            ],
            filters: {
                activo          : true,
                paginate        : true,
                include_padres  : true,
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                order_by        : 'nombre',
            },
            clientes_search     : [],
            cliente_value_search: "",
            empresa_search      : [],
            empresa_value_search: "",
            sucursal_search     : [],
            sucursal_value_search: "",
            loading_guardar     : false,
            loading             : true,
            dialog              : false,
            dialogReporte       : false,
            overlay             : false,
            fraseOverlay        : "",
            datosLogin          : "",
            documento           : {
                id              : 0,
                nombre          : "",
                descripcion     : "",
                empresa_id      : null,
                cliente_id      : null,
            },
            titulo_modal        : "",
            finaliza_carga      : false,
            accion              : "",
            sucursales          : [],
            empresas            : [],
            clientes            : [],
            departamentos       : [],
            empleados           : [],
            emp_seleccionados   : [],
            tipo_documento      : [],
            documento_value     : null,
            rol                 : null,
            carga_final         : 0,
            empresa_value       : null,
            cliente_value       : null,
            sucursal_value      : null,
            depto_value         : null,
            busqueda            : false,
            imgModal            : "/static/modal/tipoDocumentoCreate.svg",
            permisos :{
                create: false,
                update: false,
                delete: false,
            }
        };
    },
    watch: {
        cliente_value_search: function(val) {
            if(val != null){
                this.getEmpresas(val);
            }
        },
        empresa_value: function(val) {
            if(val != null){
                this.cambiaEmpresa(val);
                this.getDocumentos(val);
                this.getEmpleados();
            }
        },
        empresa_value_search: function(val) {    
            if (this.rol != null) {
                this.cambiaEmpresa(val);
            }
        },
        cliente_value: function(val){
            if(val != null){
                this.getEmpresas(val);
                this.getEmpleados();
            }
        },
        sucursal_value:function (val) {
            if(val != null){
                this.getDepartamentos(val);
                this.getEmpleados();
            }
        },
        depto_value:function (val) {
            if(val != null){
                this.getEmpleados();
            }
        }
    },
    methods: {
        listar() {
            this.loading = true;
            this.cerrarModal();
        },
        setFilters() {
            let cliente = this.cliente_value_search;
            let empresa = this.empresa_value_search;
            let sucursal = this.sucursal_value_search;

            if (this.rol == "admin") {
                cliente = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                empresa = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                sucursal = this.datosLogin.sucursal_id;
            } else if (this.rol == "admin-depto") {
                departamento = this.datosLogin.departamento_id;
            }

            let filterParams = {
                cliente_id: cliente,
                empresa_id: empresa,
                sucursal_id: sucursal,
            };

            let defaultParams = {
                activo: true,
                paginate: true,
                include_padres: true,
            };

            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }

            this.filters = defaultParams;

            this.empresa_value_search = null;

            if (this.rol == "root") {
                this.cliente_value_search = null;
            }
            this.sucursal_value_search = null;
        },
        eliminar(id, nombre) {
            let self = this;
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar el tipo documento " + nombre + "?",
                "Eliminar",
                () => {
                    this.loading = true;
                    documentoApi.deleteDocumento(id).then((response) => {
                        this.$refs.tableDocumentos.getData();
                        this.respuesta_ok("El documento ha sido eliminado satisfactoriamente");
                    })
                    .catch((err) => {
                        console.log(err);
                        Notify.ErrorToast(err.response.data.error);
                    });
                }
            );
        },
        abrirModal(accion, item = null) {
            this.errors.clear();
            this.finaliza_parametros();
            this.accion = accion;

            if(this.rol == 'root'){
                this.getClientes();
            }

            if (accion == "add") {
                this.imgModal = "/static/modal/tipoDocumentoCreate.svg";
                this.titulo_modal = "Registrar tipo de documento.";
                this.finaliza_parametros();
            } else if (accion == "update") {
                this.imgModal               = "/static/modal/tipoDocumentoUpdate.svg";
                this.titulo_modal           = "Actualizar tipo de documento.";
                this.documento.id           = item.id;
                this.documento.nombre       = item.nombre;
                this.documento.descripcion  = item.descripcion;
                this.documento.cliente_id   = item.cliente_id;
                this.cliente_value          = item.cliente_id;
                this.documento.empresa_id   = item.empresa_id;
                this.empresa_value          = item.empresa_id;
            }

            if (this.rol == "admin") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.getEmpresas(this.datosLogin.cliente_id);
            } else if (this.rol == "admin-empresa") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
                this.cambiaEmpresa(this.datosLogin.empresa_id);
            }
            setTimeout(function() {
                document.getElementById("btnModal").click();
            }, 100);
        },
        getClientes(cliente = null) {
            let self = this;
            let param = {
                activo: true,
                paginate: false,
            };

            clienteAPi.getClientes(param).then((response) => {
                this.clientes_search = response.data;
                this.clientes = response.data;
                this.finaliza_parametros();
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        getEmpresas(id) {
            let parametros = { activo: true, paginate: false, cliente_id: id };

            empresaApi.getEmpresas(parametros).then((response) => {
                this.empresa_search = this.empresas = response.data;
                if (this.accion == "update") {
                    this.cliente_value = this.documento.cliente_id;
                }
                this.finaliza_parametros();
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        cambiaEmpresa(id, sucursal = null) {
            let parametros = { activo: true, paginate: false, empresa_id: id };
            sucursalApi.getSucursales(parametros).then((response) => {
                if (this.documento.empresa_id != null) {
                    this.empresa_value = this.documento.empresa_id;
                }

                if (id != null) {
                    this.sucursal_search = response.data;
                    this.sucursales = response.data;
                }
                this.finaliza_parametros();
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        getDepartamentos(id){
            let parametros = { activo: true, paginate: false, sucursal_id: id };
            departamentoApi.getDepartamentos(parametros).then((resp)=>{
                this.departamentos = resp.data;
            }).catch((err)=>{
                console.log('Ocurrion un error al cargar los departamentos: ', err);
            })

        },
        getEmpleados(){
            this.emp_seleccionados = []
            
            let parametros = { 
                activo: true, 
                paginate: false,
                rol_name: this.rol,
                usuario_id:this.datosLogin.id, 
                cliente_id:this.cliente_value, 
                empresa_id: this.empresa_value, 
                sucursal_id: this.sucursal_value,
                departamento_id: this.depto_value};
            
            if(this.rol != null){
                empleadoApi.getEmpleados(parametros).then((resp)=>{
                    this.empleados = resp.data;
                }).catch((err)=>{
                    console.log('Ocurrio un error al cargar los empleados', err);
                })
            }
        },
        getDocumentos(id){
            let parametros = {activo: true, paginate: false, empresa_id: id};
            documentoApi.getDocumentos(parametros).then((resp)=>{
                this.tipo_documento = resp.data;
            }).catch((err)=>{
                console.log('Ocurrio un error al cargar los documentos: ', err);
            });
        },
        resetValues() {
            this.cliente_value = null;
            this.empresa_value = null;
            this.sucursal_value = null;
            this.depto_value = null;

            this.cliente_value_search = null;
            this.empresa_value_search = null;

            this.clientes = [];
            this.empresas = [];
            this.accion = "";

            this.sucursales = [];
            this.clientes = [];
            this.empresas = [];
            this.departamentos = [];
            this.empleados = [];
            this.emp_seleccionados = [];
            this.loading_guardar = false;
            this.tipo_documento = [];
            this.documento_value = null;

            this.clientes_search = [];
            this.empresa_search = [];
            this.carga_final = 0; 

            if(this.$refs.formReporte){
                this.$nextTick(()=>{
                    this.$refs.formReporte.reset();
                })
            }
        },
        guardar() {
            this.$validator.validate().then((result) => {
                if (result) {
                    this.loading_guardar = true;
                    this.documento.cliente_id = this.cliente_value;
                    this.documento.empresa_id = this.empresa_value;

                    if (this.accion === "add") {
                        documentoApi.addDocumento(this.documento).then((response) => {
                            this.$refs.tableDocumentos.getData();
                            this.respuesta_ok("El registro se creó exitosamente");
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    } else if (this.accion === "update") {
                        documentoApi.updateDocumento(this.documento).then((response) => {
                            this.$refs.tableDocumentos.getData();
                            this.respuesta_ok("El registro se actualizó exitosamente");
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    }
                }
            });
        },
        finaliza_parametros() {
            this.carga_final = this.carga_final + 1;
            if (this.carga_final == 3) {
                this.finaliza_carga = true;
            }
        },
        cerrarModal() {
            this.dialog = false;
            this.dialogReporte = false;
            this.cliente_value = null;
            this.empresa_value = null;
            this.documento  = {
                id          : 0,
                nombre      : "",
                descripcion : "",
                empresa_id  : null,
                cliente_id  : null,
            };
            this.conteo_parametros = 0;
            this.loading_guardar = false;

            //datos modal reporte
            this.sucursal_value = null;
            this.depto_value = null;

            this.empresas = [];
            this.sucursales = [];
            this.departamentos = [];
            this.empleados = [];
            this.emp_seleccionados = [];
        },
        respuesta_error(err) {
            this.cerrarModal();
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        respuesta_ok(msj) {
            this.listar();
            this.cerrarModal();
            Notify.Success("Operación exitosa", msj);
        },
        busquedaAvanzada() {
            switch (this.rol) {
                case "root":
                    this.busqueda = true;
                    break;
                case "admin":
                    this.busqueda = true;
                    break;
                case "admin-empresa":
                    this.busqueda = false;
                    break;
                case "admin-sucursal":
                    this.busqueda = false;
                    break;
                default:
                    return false;
                    break;
            }
        },

        abrirModalReporte(){
            this.titulo_modal = 'Descargar reporte'
            this.dialogReporte = true
            this.errors.clear()
            this.finaliza_carga = true
            this.resetValues()

            if(this.rol == 'root'){
                this.getClientes();
            }else if(this.rol == 'admin'){
                this.getEmpresas(this.datosLogin.cliente_id);
            }else if(this.rol == 'admin-empresa'){
                this.cambiaEmpresa(this.datosLogin.empresa_id);
                this.getDocumentos(this.datosLogin.empresa_id);
            }else if(this.rol == 'admin-sucursal'){
                this.getDepartamentos(this.datosLogin.sucursal_id);
                this.getDocumentos(this.datosLogin.empresa_id);
            }

        },

        async descargarReporte(){
            this.$refs.formReporte.validate().then(async(success)=>{
                if(success){
                   this.loading_guardar = true
                   this.dialogReporte = false
                   this.overlay = true
                   this.fraseOverlay = 'Descargando.'

                   const FileDownload = require("js-file-download")
                   const axios = require("axios")
                   let url = "reportes/documentos-empleados"
                   let today = new Date()
                   let nombre = ''

                   nombre = `Reporte_documentos_faltantes_${today.getDate()}_${today.getMonth() + 1}_${today.getFullYear()}.xlsx`;

                   let parametros = {
                        cliente_id: null,
                        empresa_id: null,
                        sucursal_id: null,
                        departamento_id: null,
                        tipo_documento_id: this.documento_value,
                        arrayEmpleados: this.emp_seleccionados,
                   }

                   if(this.rol == 'root'){
                        parametros.cliente_id = this.cliente_value;
                        parametros.empresa_id = this.empresa_value;
                        parametros.sucursal_id = this.sucursal_value;
                        parametros.departamento_id = this.depto_value;
                    }
                    else if(this.rol == 'admin'){
                        parametros.cliente_id = this.datosLogin.cliente_id;
                        parametros.empresa_id = this.empresa_value;
                        parametros.sucursal_id = this.sucursal_value;
                        parametros.departamento_id = this.depto_value;
                    }
                    else if(this.rol == 'admin-empresa'){
                        parametros.cliente_id = this.datosLogin.cliente_id;
                        parametros.empresa_id = this.datosLogin.empresa_id;
                        parametros.sucursal_id = this.sucursal_value;
                        parametros.departamento_id = this.depto_value;
                    }
                    else if(this.rol == 'admin-sucursal'){
                        parametros.cliente_id = this.datosLogin.cliente_id;
                        parametros.empresa_id = this.datosLogin.empresa_id;
                        parametros.sucursal_id = this.datosLogin.sucursal_id;
                        parametros.departamento_id = this.depto_value;
                    }
                    else if(this.rol == 'admin-depto'){
                        parametros.cliente_id = this.datosLogin.cliente_id;
                        parametros.empresa_id = this.datosLogin.empresa_id;
                        parametros.sucursal_id = this.datosLogin.sucursal_id;
                        parametros.departamento_id = this.datosLogin.departamento_id;
                    }

                    try {
                        axios({
                            method:"post",
                            url: url,
                            responseType:"blob",
                            data: parametros
                        }).then((resp)=>{
                            this.overlay = false
                            FileDownload(resp.data, nombre);
                            this.resetValues();
                        }).catch(async(error) =>{
                            this.overlay = false
                            this.loading_guardar = false
                            this.resetValues();
                            if(
                                error.request.responseType === 'blob' &&
                                error.response.data instanceof Blob &&
                                error.response.data.type &&
                                error.response.data.type.toLowerCase().indexOf('json') != -1
                            ){
                                let errorString = JSON.parse(await error.response.data.text())
                                console.log(errorString)

                                if(typeof errorString.error === 'string'){
                                    Notify.ErrorToast(errorString.error);
                                }else{
                                    let error = Object.values(errorString.error);
                                    let leyenda = ``;

                                    for (var i = 0; i < error.length; i++) {
                                        leyenda+= `* ` + error[i] + `\n`;
                                    }
                                    Notify.ErrorToast(leyenda);
                                }
                            }else{
                                Notify.ErrorToast("Error"); 
                            }
                        })
                    } catch (error) {
                        console.log(error);
                        this.overlay = false
                        this.resetValues();
                    }
                }
            })
        },

        init() {
            const elementScroll = document.querySelector("#scroll");
            if (elementScroll) {
                const ps = new PerfectScrollbar(elementScroll, {
                wheelSpeed: 2,
                wheelPropagation: true,
                minScrollbarLength: 20,
                suppressScrollY: true,
                });
            }
            $(".ps__thumb-x").css("position", "fixed");
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
        permisosVista(){
            let permisosStorage = JSON.parse(sessionStorage.getItem("permisos"))
            this.permisos.create = permisosStorage.includes("catalogo.tipos-documentos.store")
            this.permisos.update = permisosStorage.includes("catalogo.tipos-documentos.update")
            this.permisos.delete = permisosStorage.includes("catalogo.tipos-documentos.delete")
        },

    },
    created() {
        this.datosLogin = this.$session.get("usuario");
        this.rol = this.datosLogin.rol.name;
        this.permisosVista();

        if (this.rol == "root") {
            this.getClientes();
        }

        if (this.rol == "admin") {
            this.cliente_value_search = this.filters.cliente_id = this.datosLogin.cliente_id;
        } else if (this.rol == "admin-empresa") {
            this.empresa_value = this.filters.empresa_id = this.datosLogin.empresa_id;
        }
        this.busquedaAvanzada();
    },
    mounted() {
        this.listar();
        this.init();
    },
};
</script>
<style scoped>
  .btnAccionesItem {
        width: 100%;
        cursor: pointer;
        outline: 0;
        padding-left: 30px;
        padding-right: 30px;
    }
    .btnAccionesItem span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
        color: #828282;
    }
    .btnAccionesItem:hover {
        background: #F6F6F8;
    }

</style>
